<template>
  <div id="app">
    <!-- <HeaderM  :class="{show:HeaderMShow}" @menushow2="menushow2" /> -->
    <div id="page">
      <first-Component menuindex="0"></first-Component>
      <div id="scroller-wrapper" data-scrollbar >
        <home-Component></home-Component>
      </div>
      <!-- <foot></foot> -->
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import firstComponent from "@/components/first2.vue";
import Scrollbar from 'smooth-scrollbar';
import homeComponent from "@/views/about.vue";
// import { setTimeout } from "timers";
export default {
  name: "home",
  data() {
    return {
      loader: true,
      loading: false,
      noShow: {},
      wow: "",
      scrollbar: "",
      HeaderMShow: false,
    };
  },
  components: { firstComponent, homeComponent },
  mounted() {
    this.wow = new WOW();
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        this.wow.init();
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener(() => {
          this.wow.scrollHandler()
          window.pageYOffset=this.scrollbar.scrollTop
          if(window.pageYOffset>0){
            this.noShow={display:'none'}
          }
        });
      });
    },
  },
};
</script>
<style>
  body,*{
    margin: 0;
    padding: 0;
font-family: inherit;
  }
  ul,li,p,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
  }
  #app {
    font-family: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    overflow: hidden;
  }
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #98A48E!important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
</style>
